import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import config from "../../config";
import { Menubar } from "primereact/menubar";
import { SplitButton } from "primereact/splitbutton";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useAuthState } from "../../Context";
import { useAuthDispatch, getUserAttributes } from "../../Context";
import CriteriaManagement from "../CriteriaManagement/CriteriaManagement";
import { Edit } from "@material-ui/icons";

export default function NavBar() {
  

  const { userGroup, userAttributes } = useAuthState();
  const { signOut, route } = useAuthenticator((context) => [context.user]);
  // const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  

  // Log the rendering of NavBar and the current state
  // console.log("NavBar rendered, authStatus:", authStatus, "userGroup:", userGroup);
  // console.log("NavBar rendered, route from amplify useAuthenticator:", route);



  // console.log("user", user);

  const navigate = useNavigate(); // useNavigate hook
  const dispatch = useAuthDispatch();
  const location = useLocation(); 
  // console.log("NavBar rendered, location:", location.pathname);

  useEffect(() => {
    if (route !== "signOut") {
      getUserAttributes(dispatch)
    }
  }, [dispatch, route]);

  const handleNavigate = (path) => {
    navigate(path);
    // dispatch({ type: "NAVIGATE", payload: path });
  };

  // Function to calculate enabled pages
  const getEnabledPages = () => {
    return Object.values(pageMappings).filter((page) => {
      const featureConfig = config.FEATURE_FLAGS[page.feature];
      if (!featureConfig || !featureConfig.enabled) {
        return false; // Exclude if the feature is not enabled
      }
      if (featureConfig.roles && featureConfig.roles.length > 0) {
        return userGroup?.some((role) => featureConfig.roles.includes(role));
      }
      return true; // enable page if eatureConfig.roles is not defined
    });
  };

  const pageMappings = {
    dashboard: {
      feature: "DASHBOARDS",
      label: "Dashboards",
      icon: "pi pi-chart-line",
      path: "/dashboard",
    },
    documents: {
      feature: "DOCUMENTS",
      label: "Documents",
      icon: "pi pi-file",
      path: "/documents",
    },
    dataupload: {
      feature: "DATA_UPLOAD",
      label: "Data Upload",
      icon: "pi pi-file-edit",
      path: "/dataupload",
    },
    criteriaManagement: {
      feature: "CRITERIA_MANAGEMENT",
      label: 'Criteria Management',
      icon: 'pi pi-list',
      path: "/criteriamanagement"
    },
    data: {
      feature: "DATA",
      label: "Data",
      icon: "pi pi-table",
      path: "/data"
    },
    report: {
      feature: "REPORT",
      label: "Report",
      icon: "pi pi-chart-bar",
      path: "/report",
    },
    admin: {
      feature: "ADMIN",
      label: "Admin",
      icon: "pi pi-cog",
      path: "/admin",
    },
  };

  const enabledPages = getEnabledPages();
  // console.log("Enabled Pages:", enabledPages);
  // console.log("location.pathname:", location.pathname);

  const getFirstPathSegment = (path) => path.split("/")[1] || "";


  const items = enabledPages.map((page) => ({
    label: page.label,
    icon: page.icon,
    command: () => navigate(page.path),
    className: getFirstPathSegment(location.pathname) === getFirstPathSegment(page.path)
      ? "p-menuitem p-focus"
      : "p-menuitem",
  }));

  const start = (
    <div style={{ padding: "0 var(--left-side-padding)" }}>
      <img
        alt={config.logoName}
        src={config.logoPath}
        style={{ height: "2.5rem" }}
      />
    </div>
  );

  const menuItems = [
    // {
    //   label: 'Profile',
    //   icon: 'pi pi-user',
    //   command: () => {
    //     // Profile action, for later implementation
    //   }
    // },
    {
      label: "Logout",
      icon: "pi pi-sign-out",
      command: () => {
        try {
          signOut(); 
          dispatch({ type: "SIGN_OUT" }); // Clear all states in your global state
          console.log("User signed out successfully.");
        } catch (error) {
          // Handle any errors that occur during sign-out
          console.error("Error during sign-out:", error);
        }
      },
    },
  ];

  const buttonTemplate = (
    <span style={{ display: "flex", alignItems: "center" }}>
      <span>
        {userAttributes?.given_name
          ? `Welcome, ${userAttributes.given_name}`
          : "Welcome"}
      </span>
      <i className="pi pi-user" style={{ marginLeft: "0.5rem" }}></i>
    </span>
  );

  const end = (
    <div style={{ display: "flex", alignItems: "center" }}>
      <SplitButton
        buttonTemplate={buttonTemplate}
        model={menuItems}
        className="p-button-text"
      />
    </div>
  );

  return (
    <Menubar
      model={items}
      start={start}
      end={end}
      style={{ borderRadius: "0" }}
    />
  );
}
